// п. 20–21 (ФЗ-152, РГ-01/РГ-02/РГ-08). Запрос кода, проверка кода и завершение
// активации приглашения.
//
// Маршруты бэкенда (открытые, до входа):
//   POST /activation/code     { email } → { requested: true }
//   GET  /activation/consent             → { documentCode, version, text, publishedAt }
//   POST /activation/verify   { email, code } → { confirmed, confirmationToken }
//   POST /activation/complete { … }      → { userId, state: "active" }
//
// Ответ на запрос кода **одинаков** для внесённого и невнесённого адреса — по
// нему нельзя узнать, есть ли учётная запись (РГ-01).

import $api from "../http";

export interface ActivationCodeAnswer {
  requested: boolean;
}

export interface ActivationConsent {
  documentCode: string;
  version: string;
  text: string;
  publishedAt: string | null;
}

export interface ActivationVerifyAnswer {
  confirmed: boolean;
  confirmationToken: string;
}

export interface ActivationCompletePayload {
  email: string;
  confirmationToken: string;
  password: string;
  firstName: string;
  lastName: string;
  surName?: string | null;
  tel?: string | null;
  consentAccepted: boolean;
  /** РГ-02: версия текста, которую человек видел, — а не действующая на момент отправки. */
  consentVersion: string | null;
}

export default class ActivationService {
  static async requestCode(email: string): Promise<ActivationCodeAnswer> {
    const response = await $api.post<ActivationCodeAnswer>("/activation/code", {
      email,
    });

    return response.data;
  }

  static async verify(
    email: string,
    code: string,
  ): Promise<ActivationVerifyAnswer> {
    const response = await $api.post<ActivationVerifyAnswer>(
      "/activation/verify",
      { email, code },
    );

    return response.data;
  }

  static async consent(): Promise<ActivationConsent> {
    const response = await $api.get<ActivationConsent>("/activation/consent");

    return response.data;
  }

  static async complete(
    payload: ActivationCompletePayload,
  ): Promise<{ userId: number; state: string }> {
    const response = await $api.post<{ userId: number; state: string }>(
      "/activation/complete",
      payload,
    );

    return response.data;
  }
}
